import { Injectable } from '@angular/core';
import { FileDto } from '@shared/service-proxies/service-proxies';
import { AppConsts } from '@shared/AppConsts';

@Injectable()
export class FileDownloadService {

    downloadTempFile(file: FileDto) {
        const url = AppConsts.remoteServiceBaseUrl + '/File/DownloadTempFile?fileType=' + file.fileType + '&fileToken=' + file.fileToken + '&fileName=' + file.fileName;
        location.href = url; //TODO: This causes reloading of same page in Firefox
    }
}



// WEBPACK FOOTER //
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/shared/utils/file-download.service.ts